import { render, staticRenderFns } from "./TemplateMessage.vue?vue&type=template&id=34e88c01&scoped=true"
import script from "./TemplateMessage.vue?vue&type=script&lang=js"
export * from "./TemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessage.vue?vue&type=style&index=0&id=34e88c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e88c01",
  null
  
)

export default component.exports